import { useParams } from "react-router";
import CompanyDetail from "../components/Company/CompanyDetail";

function Klient() {
  const { client_id } = useParams();
  return (
    <>
      {" "}
      <div className="card">
        <div className="card-body">
          {client_id && <CompanyDetail company_id={client_id} />}
        </div>
      </div>
    </>
  );
}

export default Klient;
